import React, {Component} from 'react'
import {Carousel} from 'antd'
import axios from 'axios'

import 'styles/slider.css'

class Slider extends Component {
  constructor() {
    super();
    this.state = {
      data: [
        {
          'img':'slider1'
        },
        {
          'img':'slider2'
        },
        {
          'img':'slider3'
        }
      ]
    }
  }

  componentDidMount() {
    // this.ajaxData();
  }

  render() {
    let that = this;
    return (
      <Carousel autoplay autoplaySpeed={5000} className='app-slider'>
        {
          that.state.data.map((item, index) => {
            return (
              <div key={index}>
                <a href=''>
                  <img className='slider-img' src={'images/'+item.img+'.jpg'} alt='slider'/>
                </a>
              </div>
            )
          })
        }
      </Carousel>
    )
  }

  ajaxData() {
    let that = this;
    axios.get('api/slider.json').then((response) => {
      if (response.data.success === 0) {
        that.setState({
          data: response.data.data
        })
      }
    })
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Carousel.js